"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hilModuleResolutionTypeSchema = exports.HilModuleResolutionType = void 0;
const zod_1 = require("zod");
var HilModuleResolutionType;
(function (HilModuleResolutionType) {
    HilModuleResolutionType["SigmaModel"] = "SIGMA_MODEL";
    HilModuleResolutionType["PackageStore"] = "PACKAGE_STORE";
    HilModuleResolutionType["NonElectrical"] = "NON_ELECTRICAL";
})(HilModuleResolutionType || (exports.HilModuleResolutionType = HilModuleResolutionType = {}));
exports.hilModuleResolutionTypeSchema = zod_1.z.nativeEnum(HilModuleResolutionType);
//# sourceMappingURL=hil-module-resolution-type.js.map